// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i8g8","colMin":"styles_colMin__2L2_v"};